module.exports = __webpack_public_path__ + "img/yb1.940d3bed.jpg";